import { ProjectEditResolver } from './../projects/services/project.resolver';
import {
  TimeTableEditResolver,
  TimeTableListResolver,
  EmployeeDropdownResolver,
  TypeOfWorkDropdownResolver,
  ApprovalPersonDropdownResolver,
  ProjectDropdownResolver,
} from './services/timetable.resolver.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TimetableListComponent } from './components/timetable-list/timetable-list.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CreateTimetableComponent } from './components/new-timetable/new-timetable.component';
import { EditTimetableComponent } from './components/edit-timetable/edit-timetable.component';
import { TimetableComponent } from './timetable.component';
import { TimetableFormComponent } from './timetable-form.component';
import { SharedModule } from 'primeng/api';
import { TimetableServices } from './services/timetable.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ApprovalPersonResolver } from '../employees/services/employeeleave.resolver.service';
@NgModule({ declarations: [TimetableComponent, TimetableListComponent],
    exports: [TimetableComponent, TimetableListComponent, KubaExportModule],
  imports: [
    BrowserModule,
    TableModule,
    SharedModule,
    FormsModule,
        DatePickerModule,
    EditorModule,
    ContextMenuModule,
    MenuModule,
    DialogModule,
    ReactiveFormsModule,
        SelectModule,
        TextareaModule,
    InputTextModule,
    TranslatePipe, TranslateDirective,
    AppSharedModule,
    RouterModule,
    ButtonModule,
    KubaExportModule],
  providers: [
    TimetableServices,
    TimeTableListResolver,
    TimeTableEditResolver,
    TypeOfWorkDropdownResolver,
    EmployeeDropdownResolver,
    ApprovalPersonDropdownResolver,
    ProjectDropdownResolver,
    ApprovalPersonResolver,
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class TimetableModule {}
